import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, URLSearchParams, Response } from '@angular/http';
import { environment } from 'environments/environment';
import 'rxjs/add/operator/map'
import { HttpHeaders } from '@angular/common/http';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthService {
    token: string;

    constructor(private router: Router, private http: Http, private angularFireAuth: AngularFireAuth) { }

    signupUser(email: string, password: string) {
        //your code for signing up the new user
    }

    checkToken<T>(callback): Observable<T> {
        if (new Date(localStorage.getItem('tokenWasCreated'))) {
            this.angularFireAuth.auth.currentUser.getIdToken().then((decodedToken) => {
                localStorage.setItem('token', decodedToken);
                localStorage.setItem('tokenWasCreated', new Date().toString());
                return callback();
            });
        }
        return callback();
    }

    signinUser(email: string, password: string) {
        this.angularFireAuth.auth.signInWithEmailAndPassword(email, password).then((user) => {
            this.angularFireAuth.auth.currentUser.getIdToken().then((decodedToken) => {
                localStorage.setItem('token', decodedToken);
                localStorage.setItem('account', JSON.stringify({
                    id: decodedToken.uid,
                    name: decodedToken.name,
                    email: decodedToken.email,
                    email_verified: decodedToken.email_verified,
                }));
                // localStorage.setItem('token', responseObject.data.token);
            });
        }).catch((error) => {
            // this.loading = false;
            console.error(error);
        });

        // Observable.of({ success: true }).map(response => response);

        //your code for checking credentials and getting tokens for for signing in user
        /* return this.http.post(environment.apiUrl + '/v' + environment.apiVersion + '/auth/login', { email: email, password: password }, new RequestOptions({ headers: new Headers({ 'Content-Type': 'application/json' }) }))
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                let responseObject = response.json();
                if (responseObject.success) {

                    if (responseObject.data.account && responseObject.data.token) {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        localStorage.setItem('account', JSON.stringify(responseObject.data.account));
                        localStorage.setItem('token', responseObject.data.token);
                    }
                }
            }); */
    }

    logout() {
        this.token = null;
        localStorage.removeItem('account');
        localStorage.removeItem('token');
    }

    getToken() {
        this.token = localStorage.getItem('token');
        return this.token;
    }

    isAuthenticated(route, state) {
        // here you can check if user is authenticated or not through his token 

        if (localStorage.getItem('token')) {
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
        // return true;
    }

    headers() {
        const token = localStorage.getItem('token');
        if (token || token === 'undefined') {
            return new HttpHeaders({ 'Authorization': token });
            // return new RequestOptions({ headers: headers });
        } else {
            return new HttpHeaders({});
        }
    }

    /* prepareRequestOptions(params: any[]): RequestOptions {

        let requestOptions = this.jwt();

        if (params && params.length > 0) {
            let searchParams: URLSearchParams = new URLSearchParams();
            for (let i = 0; i < params.length; i++) {
                searchParams.set(params[i].param, params[i].val);
            }
            requestOptions.search = searchParams;
        }
        return requestOptions;
    } */
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.service.ts